<template>
  <div class="time-picker">
    <label class="time-picker__label heading" :for="name">{{ label }}</label>
    <AntFormItem>
      <AntTimePicker
        v-bind="$attrs"
        v-on="$listeners"
        v-decorator="[name, {
          initialValue: initialValue && $moment(initialValue),
          preserve,
        }]"
        :format="$t('timeFormat.short')"
        use12Hours
      />
    </AntFormItem>
  </div>
</template>

<script>
import {
  Form as AntForm,
  TimePicker as AntTimePicker,
} from 'ant-design-vue';

export default {
  name: 'TimePicker',
  components: {
    AntFormItem: AntForm.Item,
    AntTimePicker,
  },
  props: {
    name: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      default: null,
    },
    initialValue: {
      type: Number,
    },
    preserve: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style lang="scss">
  .time-picker {
    &__label {
      display: block;
      font-size: 14px;
      font-weight: 600;
      margin-bottom: 8px;
    }

    .ant-form-item-children {
      height: 100%;
    }

    .ant-time-picker {
      width: 100%;
    }

    .ant-time-picker-input {
      border-radius: 12px;
      border: 1px solid $grayLightest !important;
      font-size: 13px;
      font-weight: 500;
      height: 50px;
      letter-spacing: .3px;
      padding: 0 20px;
      width: 100%;

      &::placeholder {
        color: $gray;
        opacity: .41;
      }
    }
  }
</style>
